import { createFileRoute } from '@tanstack/react-router'

import { TechnicalError } from '@orus.eu/error'
import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PartnersContractPage as PartnerContractPage } from '../../../../components/pages/backoffice/partners/partners-contract-page/partners-contract-page.tsx'
import { PlatformContractPage } from '../../../../components/pages/backoffice/platform/platform-contract-page/platform-contract-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'
import { useBackofficeUser } from '../../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/')({
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      throw new TechnicalError('There should have been a backoffice user at this point')
    }

    return (
      <PermissionChecker
        requiredPermissions={[
          anyOfPermissions('contract.read', 'contract.read.relatedOnly', 'contract.read.allowedOnly'),
        ]}
      >
        {backofficeUser.type === 'platform' ? (
          <PlatformContractPage />
        ) : (
          <PartnerContractPage subscriptionId={subscriptionId} />
        )}
      </PermissionChecker>
    )
  },
})
